// globalData.js

export default {
  pollingInterval: null,
  date: '连接中',
  status: '--',
  selectedTabIndex: 0,
  tableList: null,
  selectMap: [
    {
      name: '黄金',
      type: 'GOLD',
      state: true
    },
    {
      name: '白银',
      type: 'SILVER',
      state: true
    },
    {
      name: '铂金',
      type: 'PLATINUM',
      state: true
    },
    {
      name: '钯金',
      type: 'PALLADIUM',
      state: true
    },
    {
      name: '铑金',
      type: 'Rhodium',
      state: true
    },
    // {
    //   name: '现料9999',
    //   type: 'AU9999SELF',
    //   state: true
    // },
    {
      name: '黄金9999',
      type: 'AU9999',
      state: true
    },
    {
      name: '黄金(T+D)',
      type: 'AUTD',
      state: true
    },
    {
      name: '白银(T+D)',
      type: 'AGTD',
      state: true
    },
    {
      name: '铂金9995',
      type: 'TMAP9995',
      state: true
    }
    // {
    //   name: '伦敦金',
    //   type: 'XAU',
    //   state: false
    // },
    // {
    //   name: '伦敦银',
    //   type: 'XAG',
    //   state: false
    // },
    // {
    //   name: '伦敦铂',
    //   type: 'XAP',
    //   state: false
    // },
    // {
    //   name: '伦敦钯',
    //   type: 'XPD',
    //   state: false
    // },
    // {
    //   name: '美元',
    //   type: 'USDCNH',
    //   state: false
    // }
  ],
  tabs: [
    { name: '行情', selected: true, defaultImage: require('../../static/download.png'), selectedImage: require('../../static/download-selected.png') },
    { name: '快讯', selected: false, defaultImage: require('../../static/newsletter.png'), selectedImage: require('../../static/newsletter-selected.png') },
    { name: '简介', selected: false, defaultImage: require('../../static/consult.png'), selectedImage: require('../../static/consult-selected.png') }
  ],
  dialogOpen: false,
  dialogOpenOther: false,
  selectMapOther: [
    {
      name: '黄金9999',
      type: 'AU9999',
      state: true
    },
    {
      name: '黄金(T+D)',
      type: 'AUTD',
      state: true
    },
    {
      name: '白银(T+D)',
      type: 'AGTD',
      state: true
    },
    {
      name: '铂金9995',
      type: 'TMAP9995',
      state: true
    },
    {
      name: '伦敦金',
      type: 'XAU',
      state: true
    },
    {
      name: '伦敦银',
      type: 'XAG',
      state: true
    },
    {
      name: '伦敦铂',
      type: 'XAP',
      state: true
    },
    {
      name: '伦敦钯',
      type: 'XPD',
      state: true
    },
    {
      name: '美元',
      type: 'USDCNH',
      state: true
    }
  ],
  HTTP_API_URL: 'https://djkx.djkx9999.com/web/v1/prices/list'
}



// WEBPACK FOOTER //
// ./src/common/globalData.js